import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// Beaches
export const getBeaches = async (params = {}) => {
  const response = await api.get("/beaches", { params });
  return response.data;
};

export const getAllBeachesForMap = async () => {
  const response = await api.get("/beaches/all");
  return response.data;
};

export const getBeachBySlug = async (slug) => {
  const response = await api.get(`/beaches/${slug}`);
  return response.data;
};

export const getNearbyBeaches = async (slug, limit = 5) => {
  const response = await api.get(`/beaches/${slug}/nearby`, { params: { limit } });
  return response.data;
};

// States & Cities
export const getStates = async () => {
  const response = await api.get("/states");
  return response.data;
};

export const getCities = async (state = null, limit = 50) => {
  const params = { limit };
  if (state) params.state = state;
  const response = await api.get("/cities", { params });
  return response.data;
};

// Stats
export const getStats = async () => {
  const response = await api.get("/stats");
  return response.data;
};

// SEO Articles
export const getFloridaCitiesForSeo = async () => {
  const response = await api.get("/seo/florida-cities");
  return response.data;
};

export const getStateCitiesForSeo = async (stateSlug) => {
  const response = await api.get(`/seo/${stateSlug}/cities`);
  return response.data;
};

export const getSeoArticleData = async (articleType, citySlug, stateSlug = null) => {
  const params = {};
  if (stateSlug) params.state = stateSlug;
  const response = await api.get(`/seo/article/${articleType}/${citySlug}`, { params });
  return response.data;
};

// Blog
export const getBlogArticles = async () => {
  const response = await api.get("/blog");
  return response.data;
};

export const getBlogArticle = async (slug) => {
  const response = await api.get(`/blog/${slug}`);
  return response.data;
};

// Contact
export const submitContactForm = async (form) => {
  const response = await api.post("/contact", form);
  return response.data;
};

export default api;
